<template>
    <zen-one
        :showuserinfo="false"
        title="Cukai Tanah:: Laporan Mukim"
        :crumbs="crumbs"
    >
        <z-page :title="`Laporan Terimaan Mengikut Jabatan`" :append-button="true">
            <w-flex column :gap="3">
                  <w-form @submit.prevent="filter">
                    <w-flex column :gap="3">
                        <w-flex :columns="{ xs: 1 }" :gap="3">
                            <w-input
                              type="date"
                              v-model="searchParams.tarikh_dari"
                              outline
                              label="Tarikh Dari"
                              label-position="left"
                            >
                            </w-input>
                            <w-input
                              type="date"
                              v-model="searchParams.tarikh_hingga"
                              outline
                              label="Tarikh Hingga"
                              label-position="left"
                            >
                            </w-input>
                            <w-button
                                :loading="loading"
                                class="align-self-end"
                                type="submit"
                            >
                            <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </w-flex>
                    </w-flex>
                </w-form>
                <w-flex class="justify-space-between">
                    <w-button bg-color="success" :loading="loading" class="align-self-end"  @click="printPdf()">
                        <w-icon class=" mr2 "> fal fa-print</w-icon>
                        &nbsp;Cetak
                    </w-button>
                </w-flex>
            </w-flex>
            <w-card v-for="data in data"  loading="loading">
                <p>Pecahan Jenis Perbendaharaan Bagi Daerah :<b>{{data.daerah}}</b></p>
                <table class="table-dashboard" width="100%"  loading="loading">
                    <thead>
                        <tr>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:20%; ">No. Per</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:50%; ">Perihal Bendahari</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:15%; ">Resit</td>
                            <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:15%; ">Jumlah</td>
                        </tr>
                    </thead>
                    <tbody >
                        <tr v-for="w in data.data">
                            <td>{{w.kod_hasil}}</td>
                            <td>{{w.keterangan}}</td>
                            <td align="right">{{w.bilangan}}</td>
                            <td align="right">{{(w.amaun).toFixed(2)}}</td>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <td colspan="2">JUMLAH KUTIPAN UNTUK {{data.daerah}}</td>
                            <td>{{resit}}</td>
                            <td>{{jumlahPerbendeharaan(data)}}</td>
                        </tr>
                    </tbody>
                </table>
                <br>
            </w-card>
            <br>
            <p>Campuran Keseluruhan Pecahan Kod Hasil</p>
            <table class="table-dashboard" width="100%"  loading="loading">
                <thead>
                    <tr>
                        <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:20%; ">No. Per</td>
                        <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:50%; ">Perihal Bendahari</td>
                        <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:15%; ">Resit</td>
                        <td style="border-top: 1px solid black;border-bottom: 1px solid black; width:15%; ">Jumlah</td>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="w in pecahanKodHasil">
                        <td>{{w.kod_hasil}}</td>
                        <td>{{w.keterangan}}</td>
                        <td align="right">{{w.bilangan}}</td>
                        <td align="right">{{(w.butiran_amaun).toFixed(2)}}</td>
                    </tr>
                </tbody>
            </table>
            <br>
        </z-page>
    </zen-one>
</template>

<script>
import moment from "moment";
import ZResource from "@/Modules/z-resource";

export default {
    extends: ZResource,
    components: {

    },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            data:[],
            pecahanKodHasil:[],
            caraBayar:[],
            searchParams: {
                tarikh_dari: new Date().toJSON().slice(0,10),
                tarikh_hingga:new Date().toJSON().slice(0,10),
                jabatan:this.$page.props.auth.user.jabatan_id,
            },
        };
    },
    methods: {
        printPdf(){
            Object.keys(this.searchParams).forEach((key) => {
                if (this.searchParams[key] === null) {
                    delete this.searchParams[key];
                }
            });
            var queryString = Object.keys(this.searchParams)
                .map((key) => key + "=" + this.searchParams[key])
                .join("&");
            // console.log(queryString);
            window.open( `${this.apiBaseUrl}/cukai/laporan/terimaanMukimPdf?${queryString}`,"_blank");
        },
        filter() {
            this.searchParams.status =
                this.searchParams.status === "null"
                    ? null
                    : this.searchParams.status;
            this.dataGet();
        },
        async dataGet() {
            this.loading = true;
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/laporan/terimaanMukim`,
                params: this.searchParams,
                responseType: "json",
            }).then((e) => {
                this.data = e.data['data'];
                this.pecahanKodHasil=e.data['olo'];
                this.caraBayar=e.data['caraBayar'];
            });
            this.loading=false;
        },
        jumlahPerbendeharaan(kod){
            console.log(kod.data);
            var w=kod.data;

        },
    },
    mounted() {
        // this.dataJHM();
        this.dataGet();
    },
};
</script>
